import { render } from "./ImageArea.vue?vue&type=template&id=318f43e4"
import script from "./ImageArea.vue?vue&type=script&lang=js"
export * from "./ImageArea.vue?vue&type=script&lang=js"

import exportComponent from "../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__